export default async function (targetNetworkId: string) {
    if (window.ethereum) {
        const currentChainId = await window.ethereum.request({
            method: 'eth_chainId',
        });

        // return true if network id is the same
        if (currentChainId == targetNetworkId) return true;
    }

    // return false is network id is different
    return false;
};
